import React, { Suspense } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import userStore from "../zustand/userStore";
import { logout } from "../auth/authSlice";

const Header2 = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = userStore((state) => state.user);

  const logOut = () => {
    dispatch(logout());
    navigate("/home");
  };

  const containerStyle = {
    margin: 0,
    padding: "80px 20px 20px",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    // backgroundImage: `url("/images/flagbg.jpg")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundAttachment: "fixed",
    backgroundSize: "cover",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    boxSizing: "border-box",
    // backgroundColor: "#f8fbff",
    background: "linear-gradient(to right, #ffffff, #B9D9F0)",
  };

  const gridContainerStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "30px",
    maxWidth: "1000px",
    width: "100%",
  };

  const boxStyle = (color1, color2) => ({
    background: `linear-gradient(135deg, ${color1}, ${color2})`,
    borderRadius: "16px",
    padding: "40px 20px",
    color: "#333",
    fontWeight: "600",
    fontSize: "20px",
    boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
    cursor: "pointer",
    textAlign: "center",
    height: "180px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    transition: "all 0.3s ease",
  });

  return (
    <div className="container-fluid d-flex justify-content-between align-items-center">
      {/* Left Logo */}
      <img
        src="/images/docmasterLogo.png"
        alt="Logo"
        style={{ width: "120px", marginLeft: "20px" }}
      />

      {/* Right Dropdown */}
      <div className="dropdown me-3">
        <button
          className="btn btn-light dropdown-toggle d-flex align-items-center"
          type="button"
          id="userDropdown"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i className="fa fa-user me-2"></i>
          {userData.name}
        </button>
        <ul
          className="dropdown-menu dropdown-menu-end"
          aria-labelledby="userDropdown"
        >
          <li>
            <span className="dropdown-item">Profile</span>
          </li>
          {/* <li>
            <span className="dropdown-item d-flex justify-content-between align-items-center">
              Settings
              <span
                style={{
                  backgroundColor: "#ff4444",
                  borderRadius: "10px",
                  padding: "2px 8px",
                  color: "white",
                  fontSize: "12px",
                }}
              >
                50%
              </span>
            </span>
          </li>
          <li>
            <span className="dropdown-item">Help</span>
          </li> */}
          <li>
            <span className="dropdown-item" onClick={logOut}>
              <i className="fa fa-sign-out me-2"></i>
              Log Out
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Header2;
